import React, { useState } from 'react'
import { Input, Modal } from 'antd'
import styles from './style.module.scss'
import { useTranslation } from 'react-i18next'

interface CustomLabelInputProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (label: string) => void
}

function CustomLabelInput({ isOpen, onClose, onConfirm }: CustomLabelInputProps) {
  const { t } = useTranslation()
  const [labelValue, setLabelValue] = useState('')

  const handleConfirm = () => {
    if (labelValue.trim()) {
      onConfirm(labelValue.trim())
      setLabelValue('')
      onClose()
    }
  }

  const modalFooter = [
    <div key="footer" className={styles.footer}>
      <button className={styles.cancelButton} onClick={onClose}>
        {t('common.button.cancel')}
      </button>
      <button
        className={`${styles.saveButton} ${!labelValue.trim() ? styles.disabled : ''}`}
        onClick={handleConfirm}
        disabled={!labelValue.trim()}
      >
        {t('common.button.ok')}
      </button>
    </div>,
  ]

  return (
    <Modal
      title={t('contact.title.customLabel')}
      open={isOpen}
      closable={false}
      footer={modalFooter}
      width={400}
      className={styles.modal}
      centered
    >
      <div className={styles.container}>
        <div className={styles.labelField}>
          <label>{t('contact.menu.name')}</label>
          <Input
            value={labelValue}
            onChange={(e) => setLabelValue(e.target.value)}
            placeholder={t('contact.menu.name')}
            autoFocus
          />
        </div>
      </div>
    </Modal>
  )
}

export default CustomLabelInput
